import React from 'react';
import { useLivePageContent } from '@/hooks/usePageContent';
import { PublicLayout } from '@/components/public/PublicLayout';
import { Seo } from '@/components/Seo';
import { SilaWorld3D } from '@/components/public/SilaWorld3D';
import { ParkReviews } from '@/components/public/ParkReviews';

const str = (v) => (typeof v === 'string' || typeof v === 'number' ? String(v) : '');

export default function Parchi3DWorld() {
  const ov = useLivePageContent('parchi');

  const title = str(ov.title) || 'Il Parco della Sila in 3D';
  const desc = str(ov.lead) || 'Vola sul Parco Nazionale della Sila in 3D fotorealistico: sentieri reali, punti panoramici e prenotazione tour.';

  return (
    <PublicLayout>
      <Seo title={title} description={desc} path="/parchi-3d" />
      <SilaWorld3D />
      <ParkReviews />
    </PublicLayout>
  );
}
